import api from "api";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";
import { queryKeys } from "utils/misc";

interface Therapist {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  language_code?: string;
}

interface TherapistsListResponse {
  items: Therapist[];
}

export const useTherapistsList = () => {
  const patientId = useId();
  const key = queryKeys.therapistsList(patientId);

  return useQuery<Therapist[]>(key, async () => {
    const response = await api("GET /messages/therapists", {
      query: { patient_id: patientId },
    });
    const data: TherapistsListResponse = await response.json();
    return data.items;
  });
};
